import { FC } from "react";
import "./Table.scss";

export interface TableDisplayData {
    type: "TABLE";
    title?: string;
    headers: string[];
    rows: string[][];
}

export interface TableProps {
    readonly table: TableDisplayData;
}

export const Table: FC<TableProps> = ({ table }) => {
    return (
        <div className="xappw-table">
            {table.title && <div className="xappw-table__header">{table.title}</div>}
            <div className="xappw-table__container">
                <table>
                    <thead>
                        <tr>
                            {table.headers.map((header, i) => (
                                <th key={`${header}-${i}`} scope="col">{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {table.rows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Table;
